import { Component, HostBinding, input } from '@angular/core';
import { SvgIconComponent } from "../../svg-icon/svg-icon.component";

@Component({
  selector: 'app-control-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.css'],
  imports: [SvgIconComponent]
})
export class SwitcherComponent {

  checked = input<boolean>(false)
  disabled = input<boolean>(false)

  @HostBinding('class')
  get cssClass() {
    return this.disabled() ? 'disabled' : (this.checked() ? 'checked' : '')
  }

}
